<template>
    <div class="row roots">
        <div class="col-sm-6">
            <div class="card root">
                <div class="card-header text-white bg-dark">
                    Add IP
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>IP</label>
                        <div class="input-group">
                            <input
                                v-model.trim="ip"
                                :disabled="loading"
                                type="text"
                                class="form-control"
                            />
                        </div>
                        <small v-if="myIP != null" class="form-text text-muted"
                            >Your public IP address:
                            <b>{{ myIP }}</b>
                        </small>
                    </div>

                    <div class="form-group">
                        <label>Quota</label>
                        <div class="input-group">
                            <select v-model="quota" class="form-control">
                                <option
                                    v-for="quotaOpt in quotaOpts"
                                    :key="quotaOpt.value"
                                    :value="quotaOpt.value"
                                >
                                    {{ quotaOpt.label }}
                                </option>
                            </select>
                        </div>
                        <small class="form-text text-muted"
                            >Only <b>Reseller</b> plan or <b>above</b> can set
                            IP quota</small
                        >
                    </div>

                    <div class="form-group">
                        <label>Region</label>
                        <div class="input-group">
                            <select v-model="region" class="form-control">
                                <option
                                    v-for="country in countries"
                                    :key="country.code"
                                    :value="country.code"
                                >
                                    {{ country.name }}
                                </option>
                            </select>
                        </div>
                        <small class="form-text text-muted">
                            FTL/SUP/SNKRS/SHOP proxies only live during release date (1-2 hours before)
                        </small>
                    </div>

                    <div class="form-group">
                        <label>Sticky</label>
                        <div class="input-group">
                            <select v-model="sticky" class="form-control">
                                <option
                                    v-for="stickyOpt in stickyOpts"
                                    :key="stickyOpt.value"
                                    :value="stickyOpt.value"
                                >
                                    {{ stickyOpt.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <button
                        :disabled="loading"
                        class="btn btn-dark"
                        @click="create"
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card example">
                <div class="card-header text-white bg-danger">
                    Notes
                </div>
                <div class="card-body">
                    <ul>
                        <li>
                            <b>Backconnect proxy</b> rotates proxy ip address
                            <b>every requests</b> or <b>1 min(Sticky)</b> or
                            <b>10 min(Sticky)</b> for no risk of ban.
                        </li>
                        <li>
                            After adding/updating an IP, <b>wait 1-2 min</b> for
                            all servers to sync and proxy to work.
                        </li>
                        <li>
                            If bot returns <b>407 error</b> it means invalid
                            login, double check your IP.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'

import { eventBus } from '../events'
import { config, auth, proxy, popup, handler, ad } from 'website-core'

const DEFAULT_COUNTRY = 'US'

export default {
    data() {
        return {
            quotaOpts: proxy.quotas,
            countries: proxy.countries,
            stickyOpts: proxy.stickies,

            myIP: null,
            ip: '',

            quota: 0,
            region: DEFAULT_COUNTRY,
            sticky: 0,

            loading: false,
        }
    },
    async created() {
        this.countries = await ad.region.get()

        this.getMyIP()
    },
    methods: {
        async create(bulk) {
            const ip = this.ip
            const quota = this.quota
            const region = this.region
            const sticky = this.sticky

            if (ip === '') {
                return
            }

            this.loading = true

            try {
                await ad.ip.create({
                    ip: ip,
                    quota: quota,
                    region: region,
                    sticky: sticky,
                })

                // send to account list component
                eventBus.$emit('newIp', {
                    ip: ip,
                    quota: quota,
                    region: region,
                    sticky: sticky,
                })

                this.ip = ''
                if (!bulk) {
                    popup.showOK(
                        'Please wait 1-2 min for all servers to sync and proxy to work'
                    )
                }
                return
            } catch (err) {
                handler(err)
            } finally {
                this.loading = false
            }
        },
        async getMyIP() {
            try {
                const ip = await ad.ip.get()
                this.myIP = ip
            } catch (err) {
                handler(err)
            }
        },
    },
}
</script>

<style scoped>
.roots {
    margin: 1rem 0;
}
.root,
.example {
    margin: 0.5rem 0;
}
</style>
